export const MAX_SLIDER_IMAGE_COUNT = {
  MOBILE_WIDTH: 5,
  DESKTOP_WIDTH: 7
}

export const SUPPLIER_RESOURCE_BY_PRODUCT: { [key: string] : string} = {
  '545': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/545.zip',
  '546': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/546.zip',
  '547': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/547.zip',
  '548': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/548.zip',
  '549': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/549.zip',
  '550': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/550.zip',
  '551': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/551.zip',
  '2058': 'https://novelty-public-raksul.s3-ap-northeast-1.amazonaws.com/supplier-resources/morinaga/2058.zip',
  '4207': 'https://novelty-public-raksul.s3.ap-northeast-1.amazonaws.com/supplier-resources/morinaga/4207.zip'
}
export const WEARABLE_PRODUCTS_ID: number[] = [
  23,24,25,26,27,28,29,30,31,32,33,34,35,36,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304
]

export const QUICK_DELIVERY_PRODUCTS: { [key: string] : string} = {
  '1476': '93',
  '1477': '80',
  '1478': '81',
  '1479': '83',
  '1480': '173',
  '1481': '197',
  '1485': '89',
  '1486': '90',
  '1487': '82',
  '1488': '191',
  '1489': '196',
  '1490': '198',
  '1593': '175',
  '1594': '560',
  '1946': '72',
  '1947': '74',
  '2030': '216'
}
export const ENDPOINT: { [key: string] : string}  = {
  CART_ITEMS: '/cart_items/'
}
export enum SERVER_ERRORS {
  NO_TRIAL_SUPPORT = 'GP001'
}

export const DELIVERY_DATE_OPTIONS = [
  {
    type: 'zipcode',
    label: '郵便番号から入力'
  },
  {
    type: 'address',
    label: '登録した住所から入力'
  }
]

export const ENDPOINTS = {
  PRODUCTS: '/api/v1/products/%id',
  ESTIMATE_ITEMS: '/estimate_items',
  ESTIMATE_ITEM: '/estimate_items/%s',
  ESTIMATE: '/api/v1/printable_skus/%id/estimate',
  PRICE_TABLE: '/api/v1/printable_skus/%id/price_table'
}

export const DAY_LABELS = ['日', '月', '火', '水', '木', '金', '土']

export enum ADDRESS_TYPE {
  ZIPCODE = 'zipcode',
  ADDRESS = 'address'
}

export const ZIPCODE_LOCAL_STORAGE_KEY = 'user_preferred_zipcode'
